import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { ConcessaoService } from '../../../../../../services/mob/concessao.service';
import { VistoriaSearch } from '../../../../../../services/mob/vistoria.search';


@Component({
  selector: 'dropdown-concessao-coletivo-rural',
  templateUrl: './dropdown-concessao-coletivo-rural.component.html',
  styleUrls: ['./dropdown-concessao-coletivo-rural.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownConcessaoColetivoRuralComponent implements OnInit {

  concessoes = []
  vistoriaSearch: VistoriaSearch
  formGroup: FormGroup;

  constructor(
    private _concessaoService: ConcessaoService,
    private _control: ControlContainer,
  ) { 
    
  }
  

  ngOnInit() {
    this.formGroup = this._control.control as FormGroup;
    this.load()

  }

  click(value = null){
    if(this.formGroup.get('cdPessoa')){
      this.formGroup.get('cdPessoa').setValue(value)
    }
    
  }

  
  load() {
    return this._concessaoService.findColetivoRural().then(r => {
      this.concessoes = r;
    });
  }
}
